import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-[hsl(var(--border))] bg-white/70">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-10">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 justify-between">
          <div className="flex items-center gap-3">
            <Logo size={36} />
            <div>
              <div className="font-display font-extrabold text-lg text-[color:var(--brand-purple-deep)]">JUWAI TEER</div>
              <div className="text-xs text-[color:var(--brand-purple)]/80">Juwai Teer Result &amp; Information</div>
            </div>
          </div>
          <nav aria-label="Footer" className="flex flex-wrap gap-x-5 gap-y-2 text-sm">
            <Link className="link-underline text-[color:var(--brand-purple-deep)] font-semibold" to="/about/">About</Link>
            <Link className="link-underline text-[color:var(--brand-purple-deep)] font-semibold" to="/contact/">Contact</Link>
            <Link className="link-underline text-[color:var(--brand-purple-deep)] font-semibold" to="/privacy-policy/">Privacy</Link>
            <Link className="link-underline text-[color:var(--brand-purple-deep)] font-semibold" to="/terms/">Terms</Link>
            <Link className="link-underline text-[color:var(--brand-purple-deep)] font-semibold" to="/disclaimer/">Disclaimer</Link>
          </nav>
        </div>
        <div className="mt-6 text-xs text-[color:var(--brand-purple)]/80 leading-relaxed">
          Juwai Teer is an informational platform only. We do not promote, endorse or facilitate any form of gambling.
          Results shown are for informational purposes. Common Number content is for reference and entertainment — it is
          not a guaranteed outcome.
        </div>
        <div className="mt-4 text-xs text-[color:var(--brand-purple)]/70">
          © {new Date().getFullYear()} Juwai Teer · jowaiteer.com
        </div>
      </div>
    </footer>
  );
}
